module.exports = __webpack_public_path__ + "static/media/elsoftlogo.0752145b.svg";